import { render } from "./SegmentNumberBetween.vue?vue&type=template&id=8f539f4c&scoped=true"
import script from "./SegmentNumberBetween.vue?vue&type=script&lang=ts"
export * from "./SegmentNumberBetween.vue?vue&type=script&lang=ts"

import "./SegmentNumberBetween.vue?vue&type=style&index=0&id=8f539f4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f539f4c"

export default script